'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('lodash/fp/curry');

var _curry2 = _interopRequireDefault(_curry);

var _Maybe = require('./type/Maybe');

var _Maybe2 = _interopRequireDefault(_Maybe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Lift the value in `Maybe`, return either the default value if the contained value is 'nothing', or
 * pass the value to the mapper.
 *
 * @param {any} defaultValue
 * @param {Function} mapper
 * @param {Maybe} value
  * */
exports.default = (0, _curry2.default)(function (defaultValue, operator, value) {
  return value.isNothing() ? defaultValue : operator(value.value);
});